import Immutable from "immutable";
import moment from "moment";

import {
  FETCH_ADJUSTMENT_FACTORS,
  FETCH_ADJUSTMENT_FACTORS_SUCCESS,
  FETCH_ADJUSTMENT_FACTORS_ERROR,
  USER_SIGNED_OUT,
} from "../constants/action-types";

const adjustmentFactor = Immutable.Record({
  id: undefined,
  description: undefined,
  name: undefined,
  total_volume_factor: undefined,
  stream_ids: undefined,
  is_compound: undefined,
  type: undefined,
  component_volume_factors: undefined,
});

// @ts-expect-error legacy opshub typing
export const data = new Immutable.Set([]);

export const AdjustmentFactorState = Immutable.Record(
  {
    isRequestInProgress: false,
    fetchError: false,
    fetchErrorMessage: "",
    fetchErrorStatus: "",
    lastRetrievedTime: 0,
    data: data,
  },
  "AdjustmentFactorState"
);

export default (state = new AdjustmentFactorState(), action) => {
  let newData = [];
  switch (action.type) {
    case FETCH_ADJUSTMENT_FACTORS:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = true;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
      });

    case FETCH_ADJUSTMENT_FACTORS_SUCCESS:
      // @ts-expect-error legacy opshub typing
      newData = new Immutable.Set(
        action.payload.map(
          (adjustmentFactorsData) => new adjustmentFactor(adjustmentFactorsData)
        )
      );

      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.data = newData;
        // @ts-expect-error legacy opshub typing
        s.lastRetrievedTime = moment().unix();
      });

    case FETCH_ADJUSTMENT_FACTORS_ERROR:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.fetchError = true;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = action.payload.message;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = action.payload.status;
      });

    case USER_SIGNED_OUT:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.data = new Immutable.Set([]);
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
        // @ts-expect-error legacy opshub typing
        s.lastRetrievedTime = 0;
      });

    default:
      return state;
  }
};
